import { render, staticRenderFns } from "./offline_batch_ship_dialog.vue?vue&type=template&id=57354949&scoped=true"
import script from "./offline_batch_ship_dialog.vue?vue&type=script&lang=js"
export * from "./offline_batch_ship_dialog.vue?vue&type=script&lang=js"
import style0 from "./offline_batch_ship_dialog.vue?vue&type=style&index=0&id=57354949&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57354949",
  null
  
)

export default component.exports